import React from "react";
import { useRouteMatch, Switch, Route, Redirect } from "react-router-dom";
import useViewController from "./viewController";
import BaseCard from "../../../../components/BaseCard";
import ProfileSettingsPage from "../../../ProfileSettingsPage";
import AcademicPage from "../AcademicPage";
import NavigationTabs from "../NavigationTabs";
import ProfessionalPage from "../ProfessionalPage";
import ProfileVideoPage from "../ProfileVideoPage";
import "./style.scss";

function MainInfoProfile() {
  const match = useRouteMatch();
  const { topNavigationMenu, showNavMenu } = useViewController();

  return (
    <BaseCard className="main-info-profile">
      <div className="main-info-profile__inner">
        {showNavMenu && <NavigationTabs itemsList={topNavigationMenu} />}
        <Switch>
          <Route exact path={`${match.url}`}>
            <ProfileSettingsPage />
          </Route>
          {showNavMenu && (
            <Route path={`${match.url}/professional`}>
              <ProfessionalPage />
            </Route>
          )}
          {showNavMenu && (
            <Route path={`${match.url}/academic`}>
              <AcademicPage />
            </Route>
          )}
          {showNavMenu && (
            <Route path={`${match.url}/video`}>
              <ProfileVideoPage />
            </Route>
          )}
          <Route>
            <Redirect to={`${match.url}`} />
          </Route>
        </Switch>
      </div>
    </BaseCard>
  );
}

export default MainInfoProfile;
